
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.85 10.9c-1.5-2.2-4.4-3.2-6.9-2.2-2.2.9-3.3 2.8-3.7 4.9h-1.9c-.8-2.9-1.5-5.9-2.3-8.8-.1-.3-.2-.8-.6-.8h-5.7c-1 0-1 3.2 0 3.2h5.3c.6 2.2 1.1 4.3 1.7 6.5h-3.2c-.7 0-.7 1.6-.7 2 1.3 11.1 2.7 22.3 4 33.4-1 .9-2.3 2.7-2.7 3.2-.4.5-.6 2.9.4 2.9h10.6c1 0 .8-2.5.3-2.9-.5-.6-1.1-1.2-1.6-1.7-.8-.8-1-1.4-1.1-1.4 0-.2.1-.5.1-.7.5-4 1-7.9 1.4-11.9.6-4.8 1.2-9.7 1.8-14.5 1-.1 2-.1 3-.7 1.1-.6 2-1.7 2.5-2.8.9-2.4.8-5.5-.7-7.7zm-6.1 8.9c-.1.2-.1.5-.1.7v.3c-1.4.7-3.5-.5-4.9-.9-1.7-.5-3.3-.6-5 0-.1-1-.3-2.1-.4-3.1h10.7c0 1-.2 2-.3 3zm-2.2 18.8c-.4 3.5-1.2 7.1-1.3 10.6 0 1.2.3 2.1.8 2.9h-4.6l.3-.3c.7 0 .7-1.6.7-2-1.1-9-2.2-17.9-3.3-26.8 2.2-.8 4.1 0 6.3.6.9.3 1.9.6 2.7.4-.5 4.9-1.1 9.7-1.6 14.6zm6.8-20.9c-1 .9-1.9 1-3 1.1l.3-2.7c.3-.9.1-2.5-.6-2.5h-4.2c1.4-2.5 5.5-2.8 7.5-.9 1.6 1.5 1.6 3.6 0 5z"}})])
          )
        }
      }
    